// extracted by mini-css-extract-plugin
export default {"root":"D0oG6TSFG5LuZ_30g6lX","share":"_ttk6o0ISCoilYSpA2Xg"};